import React from 'react';
import { ChatOutlined } from '@assets';
import styled from 'styled-components';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
width: 100vw;
max-width: 480px;
position: fixed;
left: auto;
bottom: 0;
z-index: 1000;
`;

const Icon = styled(ChatOutlined)`
position: absolute;
bottom: 80px;
right: 20px;
cursor: pointer;
z-index: 1000;
width: 50px;
height: auto;

@media screen and (max-width: 365px) {
width: 40px;
}
`;

const Chat = () => {
    const navigate = useNavigate();

    const handleClicked = () => {
        navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
    }

    return (
        <Container>
            <Icon onClick={handleClicked} />
        </Container>
    );
}

export default Chat;